import { InteractionType, PopupRequest } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import "bootstrap-icons/font/bootstrap-icons.css";
import React, { useMemo } from "react";
import { loginRequest } from "../../config/authConfig";
import PageContent from "./PageContentNew";
import { ChatProvider } from "../../contexts/ChatContext";
import { endpointsCf } from "../../config/componentsConfig";

/** Pages RAG : même transport (reprise flux exhaustive = endpoint unique). */
const PAGES_WITH_EXHAUSTIVE_RESUME = new Set([
  "legal",
  "market",
  "mydeal",
  "oreima",
]);

interface PageProps {
  page: 'home' | 'legal' | 'market' | 'mydeal' | 'oreima';
}

const Page: React.FC<PageProps> = ({ page }) => {
  // Ne pas incrémenter un key local au montage : ça remontait PageContent deux fois,
  // réinitialisait ChatInput (dont ExhaustiveSearch) et empêchait la modale format sur market/mydeal.

  // Define the type for authRequest
  const authRequest: PopupRequest = {
    ...loginRequest,
  };

   // 2. Déplacer tous les useMemo et useCallback ici
  const endpoints = useMemo(
    () => ({
      threadsEndpoint: endpointsCf.threads(page),
      chatEndpoint: endpointsCf.chat(page),
      messagesEndpoint: endpointsCf.messages(page),
      feedbackEndpoint: endpointsCf.feedback(page),
      filtersEndpoint: endpointsCf.filters(page),
      exhaustiveSearchResumeEndpoint: PAGES_WITH_EXHAUSTIVE_RESUME.has(page)
        ? endpointsCf.exhaustiveSearchResume()
        : undefined,
    }),
    [page]
  );

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
    >
      <ChatProvider {...endpoints}>
        <PageContent key={page} page={page} />
      </ChatProvider>
    </MsalAuthenticationTemplate>
  );
};

export default Page;
